module.exports = __webpack_public_path__ + "static/img/contant_3.816e753.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1st/Articles/Article_8/contant_3.jpg
// module id = icLa
// module chunks = 0